(() => {
  const button = document.querySelector('.btn-scroll-top');
  const wrapper = document.querySelector('.scroll-top-btn');
  if (!button || !wrapper) return;

  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const updateVisibility = () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    wrapper.classList.toggle('hidden', scrollTop <= 350);
  };

  button.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: reducedMotion.matches ? 'auto' : 'smooth' });
  });

  window.addEventListener('scroll', updateVisibility, { passive: true });
  updateVisibility();
})();
